import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';

import { INewbuildingInfoForTgbSchema } from '../../../../../../types/adfox';
import { getTransportTypeFromGeoId } from '../../../../../../utils/getTransportTypeFromGeoId';

import type { IVillageSchema } from '../../../../../../types';
import type { TTgbNativedescGeneralWideProps } from '../components/TgbNativedescGeneralWide';
import type { TTgbNativedescGeneralContext } from '@cian/adfox-templates';

type TGetTgbNativedescGeneralWidePropsParams = {
  village: IVillageSchema;
  context: TTgbNativedescGeneralContext;
  newbuidingInfoForTgb: null | INewbuildingInfoForTgbSchema;
  sizes: TAdFoxBannerCompleteSizes;
};

export function getTgbNativedescGeneralWideProps({
  village,
  newbuidingInfoForTgb,
  context: {
    url,
    label,
    image,
    title,
    annotation,
    description,
    logoImageUrl,
    builderName,
    metro,
    metroColor,
    metroDistance,
    button,
    location,
    mortgageTermsWarning,
    mortgageWarning,
  },
  sizes,
}: TGetTgbNativedescGeneralWidePropsParams): TTgbNativedescGeneralWideProps {
  const transports: TTgbNativedescGeneralWideProps['transports'] = [];

  if (metro) {
    const iconType = village.geo?.address?.rootAddress?.id
      ? getTransportTypeFromGeoId(village.geo.address.rootAddress.id)
      : null;

    transports.push({
      iconColor: metroColor,
      iconType,
      id: 1,
      name: metro,
      remoteness: metroDistance,
    });
  }

  const tgbNativedescGeneralWideProps: TTgbNativedescGeneralWideProps = {
    logoImageUrl,
    url,
    transports,
    label,
    button,
    image,
    annotation,
    builderName,
    title,
    address: location,
    description,
    sizes,
    mortgageTermsWarning,
    mortgageWarning,
  };

  if (newbuidingInfoForTgb) {
    Object.assign<TTgbNativedescGeneralWideProps, Partial<TTgbNativedescGeneralWideProps>>(
      tgbNativedescGeneralWideProps,
      {
        address: newbuidingInfoForTgb.address,
        builderName: newbuidingInfoForTgb.publisher.name,
        logoImageUrl: newbuidingInfoForTgb.publisher.logo.url,
        transports: newbuidingInfoForTgb.transports,
      },
    );
  }

  return tgbNativedescGeneralWideProps;
}
